module.exports = __webpack_public_path__ + "static/media/bm-kataster.4282cb66.png";